import { InlineEditField, type InlineEditFieldProps } from '@exam-management/components';
import { QBankStructureLevelCategory } from '@exam-management/graphql';

import { useEditingField } from '../../hooks';
import { useQBankStructureLevelFormContext, useEditQBSLevelItem } from '../../providers';

const UNSAVED_CHANGES_ERROR_MESSAGE = 'กรุณาบันทึกการเปลี่ยนแปลงก่อนดำเนินการต่อ';

export interface QBankStructureLevelItemNameInputProps extends InlineEditFieldProps {
  category?: QBankStructureLevelCategory;
  expanded?: boolean;
  nonInfo?: boolean;
}

export default function QBankStructureLevelItemNameInput(
  props: QBankStructureLevelItemNameInputProps,
) {
  const {
    name,
    category,
    expanded: isExpanded,
    disabled: isDisabled,
    nonInfo: isNonInfo,
    ...restProps
  } = props;
  const { setError, clearErrors, getValues } = useQBankStructureLevelFormContext();
  const { updateNameOfQBankStructureLevelItem, updateQBankStructureLevelItemToInfoItem } =
    useEditQBSLevelItem();
  const editingFields = useEditingField();

  const handleClickOutside = () => {
    setError(name, {
      type: 'onBlur',
      message: UNSAVED_CHANGES_ERROR_MESSAGE,
    });
  };

  const handleConfirm = (prevValue?: string | null) => {
    const updatedName = getValues(name);
    const newValue = updatedName ?? null;

    updateNameOfQBankStructureLevelItem(name, newValue, prevValue ?? null);

    if (updatedName) {
      updateQBankStructureLevelItemToInfoItem(name);
    }
  };

  return (
    <InlineEditField
      name={name}
      disabled={isDisabled}
      nonInfo={isNonInfo}
      onConfirm={handleConfirm}
      onChangeMode={async (mode) => {
        if (mode === 'DISPLAY') {
          editingFields.data.delete(name);
          clearErrors(name);
        } else {
          editingFields.data.add(name);
        }
      }}
      onClickOutside={handleClickOutside}
      onKeyUp={(e) => {
        // Avoid space key to prevent opening the accordion
        if (e.key === ' ') {
          e.preventDefault();
        }
      }}
      slotProps={{
        textWrapper: {
          sx: (theme) => ({
            '&:hover': {
              bgcolor: isDisabled ? undefined : theme.palette.grey[100],
              '> p': {
                color: isDisabled ? undefined : theme.palette.text.primary,
              },
            },
          }),
        },
        text: {
          sx: (theme) => ({
            color:
              category === QBankStructureLevelCategory.Part && isExpanded
                ? theme.palette.common.white
                : theme.palette.text.primary,
            ...theme.typography.body2Semibold,
          }),
        },
      }}
      {...restProps}
    />
  );
}
